export class GameMarkup {
    public createHeader(screen: PIXI.Container): void {
        const block = new PIXI.Container;
        const graphics = new PIXI.Graphics();
        graphics.beginFill
    }
}